var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('div',{staticClass:"left"},[_c('i',{staticClass:"el-icon-back"})]),_c('div',{staticClass:"center"},[_c('span',[_vm._v("111")])]),_c('div',{staticClass:"right"},[_c('span',[_vm._v("admin")]),_c('i',{staticClass:"el-icon-s-fold"})])])
}]

export { render, staticRenderFns }